import { render, staticRenderFns } from "./KerstmisMenu2.vue?vue&type=template&id=72d4e108&"
import script from "./KerstmisMenu2.vue?vue&type=script&lang=js&"
export * from "./KerstmisMenu2.vue?vue&type=script&lang=js&"
import style0 from "./KerstmisMenu2.vue?vue&type=style&index=0&id=72d4e108&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports